


























import { computed, defineComponent } from "@vue/composition-api";
import { Location } from "vue-router";
import { Review } from "@scrile/api-provider/dist/api/ReviewProvider";
import { UserPublicData } from "@scrile/api-provider/dist/projects/scrileConnect/UserPublicDataProvider";
import { timeAgo } from "@/lib/time";
import { getProfileUrl } from "@/lib/urlHelpers";
import config from "@/config";
import BaseAvatar from "@/components/BaseAvatar";
import BaseIcon from "@/components/BaseIcon";
import LinkifiedText from "@/components/LinkifiedText";

export default defineComponent({
  name: "ReviewsItem",
  components: { BaseIcon, BaseAvatar, LinkifiedText },
  props: {
    review: { type: Object as () => Review, required: true },
    canRemove: { type: Boolean, default: false },
  },
  setup(props) {
    const profileUrl = computed<Location>(() => getProfileUrl(props.review.reviewerUser));

    const time = computed(() => {
      return timeAgo(props.review.time);
    });

    const linksValidation = computed(() => {
      return config.featureClickableUserLinks;
    });

    const isAllowExternalLinks = computed(() => {
      return config.featureClickableUserExternalLinks && !!(props.review.reviewerUser as UserPublicData)?.verified;
    });

    return {
      linksValidation,
      isAllowExternalLinks,
      profileUrl,
      time,
    };
  },
});
